import React from 'react';
import { PartnerReviewPage } from '../components/PartnerReviewPage';
import type { PartnerReviewConfig } from '../models/partnerReview';

const PROMOTION_CONFIG: PartnerReviewConfig = {
  fetchEndpoint: '/TierChange/promotionEligible',
  submitEndpoint: '/TierChange/submitPromotions',
  requestItemsKey: 'promotions',
  tierChangeLabel: 'Promoted to',
  candidateLabel: 'Promotion candidates',
  nextTierFilterLabel: 'Promoted to',
  exportFileName: 'MonthlyReview',
  pageTitle: 'Monthly reviews',
  pageSubtitle: 'Report will be refreshed on the 1st working day of next month.',
};

export const MonthlyReviewsPage: React.FC = () => <PartnerReviewPage config={PROMOTION_CONFIG} />;
